@if(item.navCap){
<div mat-subheader class="nav-caption ">
  {{ item.navCap }}
</div>
} @if(!item.navCap && !item.external && !item.twoLines) {
<a mat-list-item (click)="onItemSelected(item)"
   *ngIf="item?.access == true && item?.displayName !='Dashboard' "
   [ngClass]="{'mat-toolbar mat-primary activeMenu': item.route  ?item.route=='/Accountnotes'?isactive():item.route=='/reports'?isreport():item.route=='/settings'?issettings(): router.isActive(item.route, true): false, expanded: expanded, disabled: item.disabled }" class="menu-list-item {{ item.bgcolor }}">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span class="hide-menu">{{ item.displayName | translate }}</span>
  <div class="d-flex align-items-center gap-4">
    @if(item.children && item.children.length) {
    @if(item.chip) {
    <span>
      <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
    </span>
    }
    <span class="arrow-icon" fxFlex>
      <span fxFlex></span>
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </span>
    }
  </div>
  @if(item.chip && !item.children ) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
  </span>
  }
</a>
}

<!-- external Link -->
@if(!item.navCap && item.external) {
<mat-list-item onClick="window.open('//google.com')" class="menu-list-item {{ item.bgcolor }}" target="_blank">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span class="hide-menu">{{ item.displayName | translate }}</span>
</mat-list-item>
}

<!-- children -->
@if( checkUrl()) { @for(child of item.children; track child) {
<app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1" class="childmenu">
</app-nav-item>
} }

<ng-template #accountsSwitch>
  <mat-card class="custom-dialog custWid">
    <mat-card-content class="p-16">
      <div class="p-b-10">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <mat-card-title class="mat-mdc-card-title">
              <h4 class="f-s-15 f-w-600">Select Accounting Period</h4>
            </mat-card-title>
          </div>
          <!--<div class="col-lg-4 text-right">
            <div class="d-flex justify-content-end align-items-center">
              <button class="text-center btn-close-dialog" mat-dialog-close>-->
          <!--<i-tabler class="icon-20 m-r-2" name="X"></i-tabler>-->
          <!--</button>
            </div>
          </div>-->
        </div>
      </div>
      <div class="col-12 p-0 m-t-0">
        <div class="charities-list" style="max-height: 400px; overflow-y: auto;">
          <div class="m-b-0 b-t-1 p-y-10" style="border-radius: 0px; box-shadow: none; margin-bottom: 0px !important;" *ngFor="let item of AccPerData">
            <!--<div class="p-10 cust-charity-lists" style="border-radius: 0px;"   [ngClass]="{ 'activebox': item.financialPeriodsID == CurrentfinancialPeriodsID }"  (click)="OpenPeriod1(item.financialPeriodsID,item)">-->
            <div class="p-10 cust-charity-lists"
                 style="border-radius: 0px;"
                 (click)="item.financialPeriodsID !== CurrentfinancialPeriodsID && OpenPeriod1(item.financialPeriodsID, item)"
                 [ngClass]="{ 'activebox': item.financialPeriodsID == CurrentfinancialPeriodsID }"
                 [style.pointer-events]="item.financialPeriodsID == CurrentfinancialPeriodsID ? 'none' : 'auto'"
                 [style.opacity]="item.financialPeriodsID == CurrentfinancialPeriodsID ? '0.6' : '1'">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-start gap-10">
                  <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-primary text-white" style="min-width: 6%;">
                    <i-tabler name="building" class="icon-24 d-flex"></i-tabler>
                  </div>
                  <div class="info w-100">
                    <h5 class="f-w-700 lh-sm f-s-14" style="cursor: pointer;">
                      {{item.financial_Year}}
                    </h5>
                    <div class="d-flex align-items-center gap-15">
                      <p class="f-w-400 lh-sm f-s-14 m-0">{{item.current_AP_Start_Date}} - {{item.current_AP_End_Date}}</p>
                    </div>
                    <p class="f-s-12 m-0">{{item.accounting_Method}}</p>
                  </div>
                </div>
                <div class="status">
                  <span class="f-s-12 text-success bg-light-success p-4 p-x-12 rounded"> {{ status || 'Active' }}</span>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="m-b-0 b-t-1 p-y-10" style="border-radius: 0px; box-shadow: none; margin-bottom: 0px !important;">
            <div class="p-10 cust-charity-lists" style="border-radius: 0px;">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-start gap-10">
                  <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-primary text-white" style="min-width: 6%;">
                    <i-tabler name="building" class="icon-24 d-flex"></i-tabler>
                  </div>
                  <div class="info w-100">
                    <h5 class="f-w-700 lh-sm f-s-14" style="cursor: pointer;" (click)="AccountingPeriodGrid(charityID)">
                      FY 2024-2025
                    </h5>
                    <div class="d-flex align-items-center gap-15">
                      <p class="f-w-400 lh-sm f-s-14 m-0">01 Apr 2024 - 31 Mar 2025</p>
                    </div>
                    <p class="f-s-12 m-0">Accruals</p>
                  </div>
                </div>
                <div class="status">
                  <span class="f-s-12 text-success bg-light-success p-4 p-x-12 rounded">Submitted</span>
                </div>
              </div>
            </div>
          </div>-->
          <!--<div class="m-b-0 b-t-1 p-y-10" style="border-radius: 0px; box-shadow: none; margin-bottom: 0px !important;">
            <div class="p-10 cust-charity-lists" style="border-radius: 0px;">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-start gap-10">
                  <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-primary text-white" style="min-width: 6%;">
                    <i-tabler name="building" class="icon-24 d-flex"></i-tabler>
                  </div>
                  <div class="info w-100">
                    <h5 class="f-w-700 lh-sm f-s-14" style="cursor: pointer;" (click)="AccountingPeriodGrid(charityID)">
                      FY 2024-2025
                    </h5>
                    <div class="d-flex align-items-center gap-15">
                      <p class="f-w-400 lh-sm f-s-14 m-0">01 Apr 2024 - 31 Mar 2025</p>
                    </div>
                    <p class="f-s-12 m-0">Accruals</p>
                  </div>
                </div>
                <div class="status">
                  <span class="f-s-12 text-warning bg-light-warning p-4 p-x-12 rounded">Draft</span>
                </div>
              </div>
            </div>
          </div>-->
          <!--<div class="m-b-0 b-t-1 p-y-10" style="border-radius: 0px; box-shadow: none; margin-bottom: 0px !important;">
            <div class="p-10 cust-charity-lists" style="border-radius: 0px;">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-start gap-10">
                  <div class="icon icon-38 rounded d-flex align-items-center justify-content-center bg-primary text-white" style="min-width: 6%;">
                    <i-tabler name="building" class="icon-24 d-flex"></i-tabler>
                  </div>
                  <div class="info w-100">
                    <h5 class="f-w-700 lh-sm f-s-14" style="cursor: pointer;" (click)="AccountingPeriodGrid(charityID)">
                      FY 2024-2025
                    </h5>
                    <div class="d-flex align-items-center gap-15">
                      <p class="f-w-400 lh-sm f-s-14 m-0">01 Apr 2024 - 31 Mar 2025</p>
                    </div>
                    <p class="f-s-12 m-0">Accruals</p>
                  </div>
                </div>
                <div class="status">
                  <span class="f-s-12 text-success bg-light-success p-4 p-x-12 rounded">Submitted</span>
                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<!--<ngx-spinner type="none" style="z-index:999 !important">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</ngx-spinner>-->
<!--<mat-spinner strokeWidth="6" *ngIf="isLoadingResults">     </mat-spinner>-->
